import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import RootLayout from '../layouts/RootLayout';
import HomePage from '../features/home/HomePage'; 
import SupplyPage from '../features/supply/SupplyPage';
import ProviderChoicePage from '../features/provider/pages/ProviderChoicePage';
import ProviderLinkPage from '../features/provider/pages/ProviderLinkPage';
import ProfilePage from '../features/profile/ProfilePage';
import BookingPage from '../features/booking/pages/BookingPage';
import ConfirmBookingPage from '../features/booking/pages/ConfirmBookingPage';
import LoginPage from '../features/auth/pages/LoginPage';
import RegisterPage from '../features/auth/pages/RegisterPage';
import VerifyEmailPage from '../features/auth/pages/VerifyEmailPage';
import ForgotPasswordPage from '../features/auth/pages/ForgotPasswordPage';
import SuccessfulAuthPage from '../features/auth/pages/SuccessfulAuthPage';
import ErrorPage from '../pages/ErrorPage';
import CompleteRegistrationPage from '../features/auth/pages/CompleteRegistrationPage';
import { Routes } from "./RouteConstants";
import { ProtectedSupplyRoute, ProtectedBookingRoute, ProtectedConfirmBookingRoute, ProtectedProfileRoute, ProtectedDashboardRoute, ProtectedHomeRoute, ProtectedVerifyEmailRoute } from './ProtectedRoutes';
import DashboardPage from '../features/dashboard/DashboardPage';
import AdminLayout from '../features/dashboard/layout/AdminLayout';
import BlockPeriodPage from '../features/dashboard/pages/BlockPeriodPage';
import OpeningHoursPage from '../features/dashboard/pages/OpeningHoursPage';
import GuestsPage from '../features/dashboard/pages/GuestsPage';
import CouponsPage from '../features/dashboard/pages/CouponsPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import TermsAndConditionsPage from '../pages/TermsAndConditionsPage';
import PendingApprovalPage from "../features/booking/pages/PendingApprovalPage";
import BookingSuccessPage from "../features/booking/pages/BookingSuccessPage";
import EmailActionPage from "../features/booking/pages/EmailActionPage";
import EmailActionSuccessPage from "../features/booking/pages/EmailActionSuccessPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route >
      <Route path='/' element={<RootLayout />} >
        {/* Dashboard: the admin's own frame, with the calendar as its index (DECISIONS.md D32) */}
        <Route path={Routes.DASHBOARD} element={
          <ProtectedDashboardRoute>
            <AdminLayout />
          </ProtectedDashboardRoute>
        }>
          <Route index element={<DashboardPage />} />
          <Route path={Routes.DASHBOARD_BLOCK_PERIOD} element={<BlockPeriodPage />} />
          <Route path={Routes.DASHBOARD_OPENING_HOURS} element={<OpeningHoursPage />} />
          <Route path={Routes.DASHBOARD_GUESTS} element={<GuestsPage />} />
          <Route path={Routes.DASHBOARD_COUPONS} element={<CouponsPage />} />
        </Route>

        {/* Home */}
        <Route index element={
          <ProtectedHomeRoute>
            <HomePage />
          </ProtectedHomeRoute>  
        } />

        {/* Provider: the first step on a tenant with several (docs/MULTI_PROVIDER.md) */}
        <Route path={Routes.PROVIDERS} element={<ProviderChoicePage />} />
        <Route path={Routes.PROVIDER_LINK} element={<ProviderLinkPage />} />

        {/* Supply */}
        <Route path={Routes.SUPPLY} element={
          <ProtectedSupplyRoute>
            <SupplyPage />
          </ProtectedSupplyRoute>
        } />

        {/* Booking */}
        <Route path={Routes.BOOKING} element={
          <ProtectedBookingRoute>
            <BookingPage />
          </ProtectedBookingRoute> 
        } />

        {/* Login */}
        <Route path={Routes.LOGIN} element={<LoginPage />} />
        <Route path={Routes.REGISTER} element={<RegisterPage />} />
        <Route path={Routes.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={Routes.VERIFY_EMAIL} element={
          <ProtectedVerifyEmailRoute>
            <VerifyEmailPage />
          </ProtectedVerifyEmailRoute>
        } />

        {/* Confirm booking */}
        <Route path={Routes.CONFIRM_BOOKING} element={
          <ProtectedConfirmBookingRoute>
            <ConfirmBookingPage />
          </ProtectedConfirmBookingRoute>
        } />

        {/* Pending approval */}
        <Route path={Routes.PENDING_APPROVAL} element={<PendingApprovalPage />} />

        {/* Booking success */}
        <Route path={Routes.BOOKING_SUCCESS} element={<BookingSuccessPage />} />

        {/* Profile */}
        <Route path={Routes.PROFILE} element={
          <ProtectedProfileRoute>
            <ProfilePage />
          </ProtectedProfileRoute>
        } />

        {/* Documents */}
        <Route path={Routes.PRIVAY_POLICY} element={<PrivacyPolicyPage />} />
        <Route path={Routes.TERMS_AND_CONDITIONS} element={<TermsAndConditionsPage />} />

        {/* Backend Redirects */}
        <Route path={Routes.COMPLETE_REGISTRATION} element={<CompleteRegistrationPage />} />
        <Route path={Routes.SUCCESSFUL_AUTH} element={<SuccessfulAuthPage />} />

        <Route path={Routes.EMAIL_ACTION} element={<EmailActionPage />} />
        <Route path={Routes.EMAIL_ACTION_SUCCESS} element={<EmailActionSuccessPage />} />

        <Route path={Routes.ERROR} element={<ErrorPage />} />
      </Route>
    </Route>
  )
);

export default router;
